<template>
  <v-content class="experience page">
    <can I="read" a="Experience">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Experiences', to: '/experiences' },
              { exact: true, text: $route.params.id, to: `/experiences/${$route.params.id}` },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-btn small flat fab @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <CopyButton />
        </v-toolbar>

        <can I="edit" a="Experience" v-if="editing">
          <EditExperience @refresh="refresh" @cancel="cancel" :experience="experience" />
        </can>
        <ShowExperience
          v-else
          @refresh="refresh"
          @destroy="destroy"
          @edit="editing = true"
          :experience="experience"
        />
        <can v-if="experience" I="read" a="Supervisor">
          <Supervisor
            :experience="experience"
            :supervisor="experience.supervisors[0]"
            v-if="experience.supervisors && experience.supervisors.length && !editingSupervisor"
            @edit="editingSupervisor = true"
            @refresh="refresh"
            class="mt-4"
          />
          <div v-else-if="!experience.supervisors || !experience.supervisors.length">
            <can I="create" a="Supervisor">
              <v-btn v-if="!editingSupervisor" color="success" @click="editingSupervisor = true">
                <v-icon left>mdi-check</v-icon> Add Supervisor
              </v-btn>
            </can>
            <can I="create" a="Supervisor">
              <EditSupervisor
                v-if="editingSupervisor"
                :supervisor="{ name: '', position: '', email: '' }"
                :experience="experience"
                @cancel="cancelSupervisor"
                class="mt-4"
              />
            </can>
          </div>
          <EditSupervisor
            v-if="editingSupervisor && experience.supervisors && experience.supervisors.length"
            :supervisor="experience.supervisors[0]"
            :experience="experience"
            @cancel="cancelSupervisor"
          />
        </can>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import ShowExperience from '@/components/experiences/Show'
import EditExperience from '@/components/experiences/Edit'
import Supervisor from '@/components/experiences/Supervisor'
import EditSupervisor from '@/components/experiences/EditSupervisor'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: {
    ShowExperience,
    EditExperience,
    Supervisor,
    EditSupervisor,
  },
  created() {
    this.refresh()
  },
  data() {
    return { editing: false, editingSupervisor: false }
  },
  computed: {
    experience() {
      return this.$store.getters['admin/experiences/find'](this.$route.params.id)
    },
  },
  methods: {
    refresh() {
      return this.$store.dispatch('admin/experiences/fetch', this.$route.params.id)
    },
    cancel() {
      this.refresh().then(() => (this.editing = false))
    },
    cancelSupervisor() {
      this.refresh().then(() => (this.editingSupervisor = false))
    },
    destroy() {
      this.$store
        .dispatch('admin/experiences/destroy', this.$route.params.id)
        .then(() => this.$router.push('/experiences'))
    },
  },
}
</script>
